import { BaseConfig } from "../config.interface";
import { FileUploadListConfig } from "../fileUpload-list/fileUpload-list.config";
import { FileUploadPickerConfig } from "../fileUpload-picker/fileUpload-picker.config";

interface IFileUploadConfig {
    upload: FileUploadPickerConfig;
    list: FileUploadListConfig;
}


export class FileUploadConfig extends BaseConfig<IFileUploadConfig> implements IFileUploadConfig {
    upload: FileUploadPickerConfig;
    list: FileUploadListConfig;

    static baseTheme = {
        Default: new FileUploadConfig({
            list:   FileUploadListConfig.baseTheme.Default,
            upload: FileUploadPickerConfig.baseTheme.Default,
        }),
        Images: new FileUploadConfig({
            list:   FileUploadListConfig.baseTheme.Default,
            upload: FileUploadPickerConfig.baseTheme.Images,
        }),
        Image: new FileUploadConfig({
            list:   FileUploadListConfig.baseTheme.Default,
            upload: FileUploadPickerConfig.baseTheme.Image,
        }),
        ImagesAndVideos: new FileUploadConfig({
            list:   FileUploadListConfig.baseTheme.Default,
            upload: FileUploadPickerConfig.baseTheme.ImagesAndVideos,
        }),
        Document: new FileUploadConfig({
            list:   FileUploadListConfig.baseTheme.Default,
            upload: FileUploadPickerConfig.baseTheme.Document,
        }),
        Documents: new FileUploadConfig({
            list:   FileUploadListConfig.baseTheme.Default,
            upload: FileUploadPickerConfig.baseTheme.Documents,
        }),
    };

}
